<template>
  <form @submit.prevent="onSubmit">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Configure Vetted Note</p>
      </header>
      <section class="modal-card-body">
        <select-vetted-statement :horizontal="true" :organization="organization" @input="(val) => vettedStatement = val" ref="selectVettedStatement"></select-vetted-statement>
        <div class="is-clearfix" v-if="vettedStatement && vettedStatement.vettedOrderActivityRelationships && !vettedStatement.vettedOrderActivityRelationships.length">
          <div class="is-pulled-right">
            <p class="has-text-weight-bold">The selected vetted statement has not yet been configured.</p>
            <button :class="`button is-small is-danger is-pulled-right ${deleting ? 'is-loading' : ''}`" @click.prevent="onDeletedVettedStatement">
              Delete
            </button>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column is-3">
            <select-group :multiple="true" @input="(val) => onSelectInput('groupIds', val)"></select-group>
          </div>
          <div class="column is-3">
            <select-status :multiple="true" @input="(val) => onSelectInput('statusIds', val)"></select-status>
          </div>
          <div class="column">
            <select-problem :multiple="true" @input="(val) => onSelectInput('problemCodeIds', val)"></select-problem>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Cancel</button>
        <button :class="`button is-info ${loading ? 'is-loading' : ''}`">Save</button>
      </footer>
    </div>
  </form>
</template>

<script>
import SelectVettedStatement from "./selectVettedStatement";
import SelectGroup from "./selectGroup";
import SelectStatus from "./selectStatus";
import SelectProblem from "./selectProblem";
import { VettedStatementService } from "@/services/vettedStatement.service.js";

export default {
  props: {
    organization: {
      type: Object
    }
  },
  components: {
    SelectVettedStatement,
    SelectGroup,
    SelectStatus,
    SelectProblem
  },
  data: () => ({
    vettedStatement: {},
    form: {
      groupIds: [],
      statusIds: [],
      problemCodeIds: []
    },
    loading: false,
    deleting: false
  }),
  methods: {
    onSelectInput(key, value) {
      this.form[key] = value;
    },
    onSubmit() {
      this.loading = true;

      VettedStatementService.configure(this.vettedStatement.id, {
        ...this.form,
        id: this.vettedStatement.id
      }).then(
        response => {
          this.$buefy.toast.open({
            message: "Vetted statement has been configured",
            type: "is-info",
            position: "is-top-right"
          });
          this.loading = false;
          this.$emit("submit-success");
          this.$parent.close();
        },
        err => {
          this.loading = false;
          this.$parent.close(); // closing it for now since it covers the error modal
        }
      );
    },
    onDeletedVettedStatement() {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message:
          "Are you sure you want to <b>delete</b> the selected vetted statement?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deletedVettedStatement()
      });
    },
    deletedVettedStatement() {
      this.deleting = true;

      VettedStatementService.delete(this.vettedStatement.id).then(
        response => {
          this.$buefy.toast.open({
            message: "Vetted statement has been deleted",
            type: "is-info",
            position: "is-top-right"
          });
          this.$refs.selectVettedStatement.reset();
          this.$refs.selectVettedStatement.fetchOptions();
          this.vettedStatement = {};
          this.deleting = false;
          this.$emit("delete-success");
        },
        err => {
          this.deleting = false;
          this.$parent.close(); // closing it for now since it covers the error modal
        }
      );
    }
  }
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/VettedStatement/list/partials/modalConfigure.vue